import {
  isPostPaymentAbstractEnabled,
  POST_PAYMENT_ABSTRACT_FORM_STEP,
} from "./registrationModules";

export const hasRequiredPaperSubmissionData = ({
  paperTitle,
  selectedTrack,
  submissionMethod,
  abstractText,
  paperFile,
}) =>
  Boolean(
    paperTitle?.trim() &&
      selectedTrack &&
      ((submissionMethod === "TEXTAREA" && abstractText?.trim()) ||
        (submissionMethod === "FILE" && paperFile) ||
        (submissionMethod === "BOTH" && abstractText?.trim() && paperFile))
  );

export const shouldSavePaperSubmission = ({
  hasRequiredPaperData,
  step,
  isAbstractRequired,
  wantsToSubmitAbstract,
  abstractStepNumber,
}) =>
  Boolean(
    hasRequiredPaperData &&
      ((step === 3 && isAbstractRequired && wantsToSubmitAbstract === true) ||
        (step === POST_PAYMENT_ABSTRACT_FORM_STEP &&
          isPostPaymentAbstractEnabled(abstractStepNumber)))
  );

export const resolvePaperStatus = ({
  paperActionOverride,
  paperSubmissionAction,
  paperApprovalStatus,
  submissionMethod,
}) => {
  const effectivePaperAction = paperActionOverride || paperSubmissionAction;
  const currentPaperStatus = (paperApprovalStatus || "").trim().toUpperCase();
  const shouldPreserveCurrentStatus =
    !paperActionOverride && !paperSubmissionAction && !!currentPaperStatus;

  const paperStatus =
    effectivePaperAction === "submit"
      ? "SUBMITTED"
      : effectivePaperAction === "draft"
        ? "DRAFT"
        : shouldPreserveCurrentStatus
          ? currentPaperStatus
          : !submissionMethod || submissionMethod.trim() === ""
            ? "DRAFT"
            : "SUBMITTED";

  return {
    effectivePaperAction,
    currentPaperStatus,
    paperStatus,
  };
};

export const buildPaperSubmissionPayload = ({
  registrationId,
  selectedTrack,
  paperTitle,
  abstractText,
  paperStatus,
  presentationMode,
}) => ({
  registrationId,
  trackId: parseInt(selectedTrack, 10),
  title: paperTitle.trim(),
  abstractText: abstractText?.trim() || null,
  status: paperStatus,
  presentationMode: presentationMode || null,
  fileId: null,
});
